import { SESSION_PARTIAL_TEXT } from "../auth/auth-errors.ts";
import { Dialog } from "./Dialog.tsx";

/**
 * Ответ на нажатие неактивного пункта неполной сессии (9.6
 * `docs/account-adopt-design.md`): подпись на доске и часовой пояс.
 *
 * Пункт не прячется, а гаснет и по нажатию объясняет, почему: спрятанный
 * пункт человек ищет, а погашенный без объяснения считает поломкой. Запроса
 * нет, отказа после действия тоже нет: сервер ответил бы `session_partial`.
 *
 * Окном, а не подсказкой при наведении: на телефоне наведения нет, а
 * неполная сессия чаще всего именно телефонная (второе устройство ученика).
 */
export function PartialSessionNote(props: { title: string; onClose: () => void }) {
  return (
    <Dialog title={props.title} onClose={props.onClose}>
      <p>{SESSION_PARTIAL_TEXT}</p>
    </Dialog>
  );
}
